<mat-card class="aboutCard">
    <mat-card-header>
        <mat-card-title>{{ title }}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div [innerHTML]="content" class="ck-editorControl"></div>

        <div *ngFor="let image of this.images" class="imageHolder">
            <img [src]="image.image" class="max-w-100">
        </div>
    </mat-card-content>
</mat-card>
